import React from 'react';
import { FaMapMarkerAlt, FaDirections, FaArrowLeft, FaClock, FaTicketAlt } from 'react-icons/fa';

// Terminales de abordaje (fijas). Si cambian, edita este arreglo.
const TERMINALES = [
  {
    ciudad: 'Oaxaca de Juárez',
    nombre: 'Terminal Ángeles del Puerto',
    direccion: 'México 175, Ferrocarril, Artículo 123 Oriente, 68090 Oaxaca de Juárez, Oax.',
    comoLlegar: 'https://maps.app.goo.gl/gheHhqkG7NUN9zdd9',
    embed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4899.166068164022!2d-96.71668448336355!3d17.057049253484006!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85c7230027ff6309%3A0x13f55509ae17ae9!2sAutotransportes%20ANGELES%20DEL%20PUERTO!5e0!3m2!1ses!2smx!4v1782751680312!5m2!1ses!2smx',
  },
  {
    ciudad: 'Puerto Escondido',
    nombre: 'Terminal Turística Municipal Benito Juárez',
    direccion: 'Av. Oaxaca, Cuarta Pte., Hidalgo, 71980 Puerto Escondido, Oax.',
    comoLlegar: 'https://maps.app.goo.gl/aTSXdcHAT89xPCWa7',
    embed: 'https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d461.5873844610074!2d-97.07603675785523!3d15.873828814168133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTXCsDUyJzI2LjEiTiA5N8KwMDQnMzIuNiJX!5e0!3m2!1ses!2smx!4v1782751745241!5m2!1ses!2smx',
  },
];

export default function Ubicaciones() {
  return (
    <div className="min-h-screen bg-slate-900 text-white">

      {/* Barra superior */}
      <div className="w-full px-6 py-4 flex justify-between items-center border-b border-white/10">
        <a href="/" className="flex items-center gap-2 text-white hover:text-blue-400 font-medium">
          <FaArrowLeft /> Inicio
        </a>
        <a href="/mis-viajes" className="flex items-center gap-2 text-emerald-400 border border-emerald-400 px-4 py-2 rounded-full font-bold hover:bg-emerald-400/10">
          <FaTicketAlt /> Mis Viajes
        </a>
      </div>

      <div className="max-w-5xl mx-auto px-4 py-10">
        <div className="text-center mb-10">
          <h1 className="text-3xl md:text-4xl font-black flex items-center justify-center gap-3">
            <FaMapMarkerAlt className="text-blue-500" /> ¿Dónde abordar?
          </h1>
          <p className="text-slate-400 mt-2">Estas son nuestras terminales. Llega <b className="text-white">15 minutos antes</b> de tu salida.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {TERMINALES.map((t) => (
            <div key={t.ciudad} className="bg-slate-800 rounded-3xl overflow-hidden shadow-xl border border-white/10 flex flex-col">
              {/* Mapa */}
              <div className="w-full aspect-video bg-slate-700">
                <iframe
                  title={`Mapa ${t.ciudad}`}
                  src={t.embed}
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="strict-origin-when-cross-origin"
                />
              </div>

              {/* Info */}
              <div className="p-6 flex flex-col flex-1">
                <span className="text-xs font-bold text-blue-400 uppercase tracking-wide">{t.ciudad}</span>
                <h2 className="text-xl font-black mt-1">{t.nombre}</h2>
                <p className="text-slate-400 text-sm mt-2 flex items-start gap-2">
                  <FaMapMarkerAlt className="text-blue-500 mt-0.5 flex-shrink-0" /> {t.direccion}
                </p>

                <a
                  href={t.comoLlegar}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-5 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-xl flex items-center justify-center gap-2 transition active:scale-95"
                >
                  <FaDirections /> Cómo llegar
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Aviso de abordaje */}
        <div className="mt-10 bg-blue-500/10 border border-blue-500/30 rounded-2xl p-5 flex items-start gap-3">
          <FaClock className="text-blue-400 mt-1 flex-shrink-0" />
          <div className="text-sm text-slate-300">
            <p className="font-bold text-white">Recomendaciones para abordar</p>
            <ul className="list-disc pl-4 mt-1 space-y-1">
              <li>Llega al menos <b>15 minutos antes</b> de la hora de salida.</li>
              <li>Ten a la mano tu <b>boleto digital</b> (código QR) y una identificación oficial.</li>
              <li>Si tienes dudas, escríbenos por WhatsApp.</li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-10">
          <a href="/reservar" className="inline-block bg-emerald-500 hover:bg-emerald-600 text-white font-bold px-8 py-3 rounded-full transition active:scale-95">
            🎟️ Comprar boleto
          </a>
        </div>
      </div>
    </div>
  );
}
